import styled, { css } from 'styled-components';

type SidebarItemType = {
  isActived?: boolean;
  isAnswered?: boolean;
};

const desktopTimeline = css`
  &:before {
    content: '';
    width: 4px;
    height: 4px;
    display: block;
    position: absolute;
    margin: initial;
    left: 0;
    background: ${(props) => props.theme.colors['neutral-70']};
    border-radius: 50%;
    top: 5px;
  }
  &:after {
    content: '';
    width: 1px;
    height: calc(100% + 22px);
    position: absolute;
    left: 1.5px;
    background: ${(props) => props.theme.colors['neutral-70']};
    top: 8px;
  }
`;

const mobileTimeline = css`
  &:before {
    content: '';
    width: 4px;
    height: 4px;
    display: block;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    background: ${(props) => props.theme.colors['neutral-70']};
    border-radius: 50%;
    bottom: -5px;
  }
  &:after {
    content: '';
    height: 1px;
    width: calc(100% + 25px);
    position: absolute;
    background: ${(props) => props.theme.colors['neutral-70']};
    bottom: -4px;
    left: 50%;
  }
`;

export const Container = styled.div<{ isSmaller?: boolean }>`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: ${(props) => (props.isSmaller ? '860px' : '1160px')};
`;

export const QuestionText = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const QuestionHeader = styled.div`
  padding: 16px;
  background: ${(props) => props.theme.colors['neutral-30']};
`;

export const QuestionCard = styled.div`
  border-radius: 8px;
  border: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  border-top: 0;
  overflow: hidden;
`;

export const QuestionBody = styled.div`
  padding: 16px;
`;

export const Content = styled.div`
  width: 100%;
`;

export const Grid = styled.div`
  margin-top: 32px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    margin-top: 64px;
  }
`;

export const Sidebar = styled.aside`
  width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-right: 20px;
    max-width: 160px;
  }
`;

export const SidebarQuestion = styled.p<{ isMobile?: boolean }>`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: ${(props) => (props.isMobile ? 'initial' : 'none')};
  white-space: ${(props) => (props.isMobile ? 'pre' : 'initial')};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: ${(props) => (props.isMobile ? 'none' : 'flex')};
  }
`;

const activedQuestion = css`
  p {
    color: ${(props) => props.theme.colors['primary-60']};
  }
  &:before {
    background: ${(props) => props.theme.colors['primary-60']};
  }
`;

const answeredQuestion = css`
  p {
    color: ${(props) => props.theme.colors['secondary-60']};
  }
  &:before,
  &:after {
    background: ${(props) => props.theme.colors['secondary-60']};
  }
`;

export const SidebarList = styled.ul`
  display: flex;
  overflow: auto;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: initial;
  }
`;

export const SidebarItem = styled.li<SidebarItemType>`
  margin-bottom: 32px;
  margin-right: 24px;
  position: relative;
  p {
    color: ${(props) => props.theme.colors['neutral-80']};
  }
  ${mobileTimeline};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 21px;
    margin-bottom: 24px;
    ${desktopTimeline};
  }
  &:last-of-type:after {
    display: none;
  }
  ${({ isActived }) => isActived && activedQuestion};
  ${({ isAnswered }) => isAnswered && answeredQuestion};
`;

export const QuestionButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  button {
    margin: 0 12px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 130px;
  }
`;
